/**
 * Компонент индикатора статуса подключения к backend
 */

import React from 'react';
import { useBackendStatus } from '../hooks/useBackendApi';

const BackendStatusIndicator = ({ showWhenConnected = false }) => {
  const { isConnected, checking, usingBackend } = useBackendStatus();

  // Не показываем ничего если backend подключен и showWhenConnected = false
  if (isConnected && !showWhenConnected) {
    return null;
  }

  // Не показываем во время проверки
  if (checking) {
    return null;
  }

  const getStatusStyle = () => {
    if (!usingBackend) {
      return {
        background: '#fef3c7',
        color: '#92400e',
        borderColor: '#fbbf24',
      };
    }

    if (isConnected) {
      return {
        background: '#d1fae5',
        color: '#065f46',
        borderColor: '#10b981',
      };
    }

    return {
      background: '#fee2e2',
      color: '#991b1b',
      borderColor: '#ef4444',
    };
  };

  const getStatusText = () => {
    if (!usingBackend) {
      return '⚠️ Режим офлайн (моковые данные)';
    }

    if (isConnected) {
      return '✅ Подключено к backend';
    }

    return '❌ Backend недоступен, используются моки';
  };

  const style = getStatusStyle();

  const icon = !usingBackend ? '⚠️' : isConnected ? '✅' : '❌';

  return (
    <div
      title={getStatusText()}
      style={{
        position: 'fixed',
        top: '14px',
        right: '14px',
        width: 28,
        height: 28,
        borderRadius: '50%',
        fontSize: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: `1px solid ${style.borderColor}`,
        background: style.background,
        boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
        zIndex: 10000,
        cursor: 'default',
      }}
    >
      {icon}
    </div>
  );
};

export default BackendStatusIndicator;

